import { ILockAndRoll } from '@GFTypes/GameStoreTypes';

export const LOCK_AND_ROLL_DEFAULTS: ILockAndRoll = {
    triggerPositions: [],
    retriggerPositions: [],
    currentSpin: 0,
    totalSpins: 0,
    totalWin: 0,
    spinsWon: 0,
    symbols: [],
    multiplierWeights: {},
    staticJackpots: {},
    spinningSets: []
};
